/* Rquiere de mixin.js */

var subscription = {
	data () {
		return {
			listSubscriptions: [],
			methodsSubscription: {
				get: 'subscriptions',
			},
			paginationSubscriptions: [],
			searchSubscriptions: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllSubscriptions(page = 1) {
			let parameters = '?search=' + this.searchSubscriptions + '&page=' + page
			this.axiosActionIS(this.apiBackend + this.methodsSubscription.get + parameters, 'GET', 'getAllSubscriptionsResult')
        },
        getAllSubscriptionsResult(response) {
            this.listSubscriptions = response.data.data
            this.getAllSubscriptionsResultLocal(response)
        },
        getAllSubscriptionsResultLocal(response) {
            console.log('getAllSubscriptionsResultLocal no desarrollado', response)
        }
	},
};

export default subscription;